import { render, staticRenderFns } from "./ReadOnlyAutoControl.vue?vue&type=template&id=36d3c4c6&"
import script from "./ReadOnlyAutoControl.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyAutoControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports